import {PaymentStatus} from '@aboutyou/grpc-clients/grips/protos/klarna/v1/payment_details.types';
import {useTranslation} from '@aboutyou/i18n';

export const useKlarnaTranslation = () => {
  const {t} = useTranslation();

  return {
    klarnaDescription: t(
      'Now, it is even easier to manage your Klarna orders.',
    ),
    amountLeftToPay: t('Amount Left To Pay'),
    paidAmount: t('Paid Amount'),
    dueDate: t('Due Date'),
    status: t('Status'),
    statusDescription: t('Status Description'),
    totalAmount: t('Total Amount'),
    manageYourKlarnaOrder: t('Manage your order with ABOUT YOU'),
    manageYourOrdersWithKlarnaGenericError: (klarnaUrl: string): string =>
      t(
        'We are unable to retrieve your order status. Please try again to authenticate or <a href="{klarnaUrl}" target="_blank">visit Klarna directly</a>.',
        {klarnaUrl},
      ),
    statuses: (status: PaymentStatus): string => {
      switch (status) {
        case PaymentStatus.PAID:
          return t('Paid');
        case PaymentStatus.INVALID:
          return t('Invalid');
        case PaymentStatus.UNPAID:
          return t('Unpaid');
        default:
          return t('Unknown');
      }
    },
  };
};
